import {font_s_lg, font_s_md, panel_light, colors} from '@xpertdox_js/xdstyle';

export default {
  sidePanel: {
    backgroundColor: 'rgb(199, 199, 199,.05)',
    boxShadow: 'inset 0 0 2px #d3d3d3',
    position: 'fixed',
    top: '0',
    right: '0',
    border:'solid .05px rgba(0, 0, 0, .065)',
    width: '300px',
    height: '100%',
    padding: '55px 8px 8px 8px',
    overflow: 'auto'
  },
  title: {
    color: colors.xdDarkBlue,
    ...font_s_lg,
    dislpay: 'block',
    borderBottom: '1px solid rgba(0,0,0,0.2)',
    margin: 0,
    paddingBottom: '.8rem',
    marginBottom: '.8rem'
  },
  trialBlock: {
    ...panel_light,
    ...font_s_md,
    border: 0,
    boxShadow: 'none',
    marginBottom: '1rem',
    padding: '.4rem',
    position: 'relative'
  },
  trialText: {
    margin: 0,
  },
  trialContent: {
    float: 'left',
    maxWidth: '75%',
  },
  trialControls: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    left: 'auto',
    width: '25%',
    height: '100%'
  }
}
